import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
import { ProcessFlowVisual } from './visuals/ProcessFlowVisual';
import { systemSteps } from '../data/site';
export function System() {
  return <section id="system" className="border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-700" data-mp="6ndj8lqc3wgj">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-701" data-mp="arlaapk9lohx">
        <SectionLabel data-id="element-702" data-mp="fpwjqz6ndwzm">The fix</SectionLabel>

        <h2 className="mt-8 max-w-3xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-703" data-mp="fotuswsvy4mc">
          Not six services. One machine that catches leads.
        </h2>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-neutral-400" data-id="element-704" data-mp="pgheucn44jds">
          A lead comes in one end and leaves the other as a booked estimate, and you can see
          exactly where it went.
        </p>

        <div className="mt-12" data-id="element-705" data-mp="yhpcqtlpvi7c">
          <ProcessFlowVisual data-id="element-706" data-mp="ye9wvok7y54v" />
        </div>

        <ol className="mt-14 grid grid-cols-1 gap-x-10 gap-y-12 md:grid-cols-2" data-id="element-707" data-mp="13g91t2vlxa3x">
          {systemSteps.map((s, i) => <motion.li key={s.step} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.06
        }} className="relative border-l border-[#1f1f1f] pl-7" data-id="element-708" data-mp="zzk6sorgafap" data-mpi={i}>
              <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-709" data-mp="1jlqc2nn5189p" />
              <p className="font-mono text-xs tracking-[0.2em] text-neutral-600" data-id="element-710" data-mp="1eozv7y3ie8n8">{s.step}</p>
              <h3 className="mt-3 text-xl font-semibold text-white" data-id="element-711" data-mp="19uc740cf3g96">{s.title}</h3>
              <p className="mt-3 max-w-md leading-relaxed text-neutral-400" data-id="element-712" data-mp="14waiz104wqqu">{s.body}</p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}